import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';
import { UserService } from '../../../core/user/user.service';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const userService: UserService = inject(UserService);

  // Check the authentication status
  return inject(AuthService)
    .check()
    .pipe(
      switchMap((authenticated) => {
        // If the user is authenticated...
        if (authenticated) {
          // Respeita a rota inicial calculada no login (ex.: empresa nova sem acomodações
          // deve abrir '/company-initialize'). Sem initialRoute, cai na raiz ('' -> reception)
          const initialRoute = userService.getUserFromLocalStorage()?.initialRoute || '';
          return of(router.parseUrl(initialRoute));
        }

        // Allow the access
        return of(true);
      }),
    );
};
